import styled from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const AvatarContainer = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #ffffff;
    padding: ${isMobile ? '0.25rem' : '0.5rem'};
    margin: 0 0.625rem;
    margin-right: ${!isMobile && '0'};

    ${media.mobileDevice`
        width: 50px;
        height: 50px;
        padding: 0.25rem;
        margin: 0 0.625rem;
        margin-left: 0;
    `}
`;

export const Text = styled.div`
    margin: 0;
    padding: 0;
    color: #140f4b;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;

    ${media.mobileDevice`
        font-size: 25px;
    `}
`;
